import { ObjektTyp } from 'app/core/services/api-client';

export class ExpertSearch {
  SearchClause: string;
  StructureSearch: any;
  Operation: string;
  SearchQueryString: ExternalQuery;
  Kontext: ObjektTyp;
  constructor() {
    this.SearchClause = '';
  }
}

export class ExternalQuery {
  key: string;
  value: string;

  constructor() {
    this.key = '';
    this.value = '';
  }
}
